var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c("SearchTerm", {
        attrs: {
          searchInfo: _vm.searchInfo,
          searchMore: false,
          searchBaseItems: ["timeStart", "stationId", "mainOrderNo", "mobile"],
          btns: { search: true, reset: true }
        },
        on: { onChange: function() {} }
      }),
      _c(
        "div",
        { staticClass: "bairun-table-btns" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onRedoDialog } },
            [_vm._v("重开发票")]
          )
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          small: "",
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            height: "45rem",
            "tooltip-effect": "dark"
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "ID", prop: "ID", "min-width": "30" }
          }),
          _c("el-table-column", {
            attrs: { label: "开票时间", prop: "CreatedAt", "min-width": "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.CreatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "发票", prop: "invoiceCode", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v("发票代码：" + _vm._s(scope.row.invoiceCode))
                    ]),
                    _c("div", [
                      _vm._v("发票号码：" + _vm._s(scope.row.invoiceNumber))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "税额", prop: "totalTax", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v("不含税总金额：" + _vm._s(scope.row.totalAmount))
                    ]),
                    _c("div", [
                      _vm._v("总税额：" + _vm._s(scope.row.totalTax))
                    ]),
                    _c("div", [
                      _vm._v(
                        "价税合i计：" + _vm._s(scope.row.totalAmountWithTax)
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "订单信息", prop: "stationId", "min-width": "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        "油枪/油品：" +
                          _vm._s(scope.row.goodsNo) +
                          "号枪/#" +
                          _vm._s(scope.row.oilCode)
                      )
                    ]),
                    _c("div", [_vm._v("手机：" + _vm._s(scope.row.mobile))]),
                    _c("div", [
                      _vm._v("单号：" + _vm._s(scope.row.mainOrderNo))
                    ]),
                    _c("div", [
                      _vm._v(
                        "站点：" +
                          _vm._s(
                            (
                              _vm.allStationMap[String(scope.row.stationId)] ||
                              {}
                            ).stationName
                          )
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "发票类型", "min-width": "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.invoiceTypeTag(scope.row),
                          size: "small"
                        }
                      },
                      [_vm._v(_vm._s(_vm.invoiceTypeText(scope.row)))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "状态", prop: "status", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.statusTagType(scope.row),
                          size: "small"
                        }
                      },
                      [_vm._v(_vm._s(_vm.statusText(scope.row)))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "420", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.isNormalInvoice(scope.row) && scope.row.status == 2
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.onVoid(scope.row)
                              }
                            }
                          },
                          [_vm._v("红冲")]
                        )
                      : _vm._e(),
                    scope.row.scanQrUrl
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.onShowQrcode(scope.row)
                              }
                            }
                          },
                          [_vm._v("二维码")]
                        )
                      : _vm._e(),
                    scope.row.pdfUrl
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.onPreviewInvoice(scope.row)
                              }
                            }
                          },
                          [_vm._v("查看发票")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.onRefresh(scope.row)
                          }
                        }
                      },
                      [_vm._v("刷新")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.redoDialogVisible,
            title: "重开发票",
            width: "480px"
          },
          on: {
            "update:visible": function($event) {
              _vm.redoDialogVisible = $event
            },
            close: _vm.onRedoDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "redoForm",
              attrs: {
                model: _vm.redoForm,
                rules: _vm.redoRules,
                "label-width": "90px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "发票类型", prop: "invoiceType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.redoForm.invoiceType,
                        callback: function($$v) {
                          _vm.$set(_vm.redoForm, "invoiceType", $$v)
                        },
                        expression: "redoForm.invoiceType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("个人")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("公司")])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订单号", prop: "mainOrderNo" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "请输入订单号",
                      maxlength: "40"
                    },
                    model: {
                      value: _vm.redoForm.mainOrderNo,
                      callback: function($$v) {
                        _vm.$set(_vm.redoForm, "mainOrderNo", $$v)
                      },
                      expression: "redoForm.mainOrderNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "发票抬头", prop: "buyerName" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "请输入发票抬头",
                      maxlength: "100"
                    },
                    model: {
                      value: _vm.redoForm.buyerName,
                      callback: function($$v) {
                        _vm.$set(_vm.redoForm, "buyerName", $$v)
                      },
                      expression: "redoForm.buyerName"
                    }
                  })
                ],
                1
              ),
              _vm.redoForm.invoiceType == 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "税号", prop: "buyerTaxNo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "请输入税号",
                          maxlength: "30"
                        },
                        model: {
                          value: _vm.redoForm.buyerTaxNo,
                          callback: function($$v) {
                            _vm.$set(_vm.redoForm, "buyerTaxNo", $$v)
                          },
                          expression: "redoForm.buyerTaxNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "mobile" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "请输入手机号",
                      maxlength: "11"
                    },
                    model: {
                      value: _vm.redoForm.mobile,
                      callback: function($$v) {
                        _vm.$set(_vm.redoForm, "mobile", $$v)
                      },
                      expression: "redoForm.mobile"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱", prop: "email" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "选填，用于接收发票",
                      maxlength: "60"
                    },
                    model: {
                      value: _vm.redoForm.email,
                      callback: function($$v) {
                        _vm.$set(_vm.redoForm, "email", $$v)
                      },
                      expression: "redoForm.email"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "发票备注", prop: "remarks" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "100",
                      "show-word-limit": "",
                      placeholder: "选填"
                    },
                    model: {
                      value: _vm.redoForm.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.redoForm, "remarks", $$v)
                      },
                      expression: "redoForm.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.redoDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.redoSubmitting },
                  on: { click: _vm.confirmRedo }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.invoicePreviewVisible,
            title: "发票预览",
            width: "60%",
            top: "5vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.invoicePreviewVisible = $event
            },
            close: _vm.onInvoicePreviewClose
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.invoicePreviewLoading,
                  expression: "invoicePreviewLoading"
                }
              ],
              staticClass: "invoice-preview-body",
              attrs: { "element-loading-text": "发票加载中..." }
            },
            [
              _vm.invoicePreviewSrc
                ? _c("iframe", {
                    attrs: { src: _vm.invoicePreviewSrc, frameborder: "0" }
                  })
                : !_vm.invoicePreviewLoading
                ? _c("div", { staticClass: "invoice-preview-empty" }, [
                    _vm._v("暂无发票文件")
                  ])
                : _vm._e()
            ]
          ),
          _c(
            "div",
            {
              staticClass: "invoice-preview-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.invoicePreviewBlob },
                  on: { click: _vm.onDownloadInvoice }
                },
                [_vm._v("下载发票")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.qrcodeDialogVisible,
            title: "发票二维码",
            width: "420px"
          },
          on: {
            "update:visible": function($event) {
              _vm.qrcodeDialogVisible = $event
            },
            close: _vm.onQrcodeDialogClose
          }
        },
        [
          _c(
            "div",
            { staticClass: "invoice-qrcode" },
            [
              _c("vue-qr", {
                attrs: {
                  "logo-src": _vm.bairunLogo,
                  text: _vm.qrcodeText,
                  size: 300
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }